import { memo, type ReactNode } from "react";
import { type GoogleMarker } from "../../salesPartnerTypes";
import GmapsCardRightUnregistered from "./SPCompanyDetailsCardRightUnregistered";
import GmapsCardRightRegistered from "./SPCompanyDetailsCardRightRegistered";
import { userIsLoggedIn, userIsRegistered } from "../../../utils/roles";
import classNames from "classnames";
import { competences, SPCompanyDetails } from "./SPCompanyDetails";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";
import classes from "./SPCompanyDetailsCard.module.less";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";
import { useGuestCheckoutDialog } from "~/Cart/pages/CartPage/B2CCart/components/GuestCheckoutDialog/useGuestCheckoutDialog";

interface Props {
  className?: string;
  selectedMarker: GoogleMarker;
  activeTab: string;
  shareLinearConfigurationData?: string[];
  action?: ReactNode;
  openRegisterSnackbar?: () => void;
  isCheckout?: boolean;
}

export const SPCompanyDetailsCard = memo((props: Props) => {
  const { selectedMarker, activeTab, className, isCheckout } = props;

  const { t } = useTranslation();

  const isDesktop = useIsMinDesktopSize();

  const loggedIn = userIsLoggedIn();
  const registeredUser = userIsRegistered();

  const cls = classNames(
    "scha__sp__details-card",
    isCheckout && classes.reducedPadding,
    !isDesktop && classes.mobileStyling,
    className,
  );

  const [handleB2CCheckout, guestCheckoutDialog] = useGuestCheckoutDialog();

  return (
    <div className={cls}>
      <div className={classNames("scha__sp__details-card__content",isCheckout && "scha__sp__details-card__content-with-gap")}>
        {guestCheckoutDialog}
        <SPCompanyDetails
          openRegisterSnackbar={props.openRegisterSnackbar}
          className={classNames(!isCheckout && "scha__sp__details-card__left")}
          action={props.action}
          company={selectedMarker}
          activeTab={activeTab}
          isCheckout={isCheckout}
        />

        {!isCheckout ? (
          <div className="scha__sp__details-card__right">
            {!loggedIn && <GmapsCardRightUnregistered company={selectedMarker} />}
            {registeredUser && (
              <GmapsCardRightRegistered
                shareLinearConfigurationData={props.shareLinearConfigurationData}
                companyDetails={selectedMarker.address}
                company={selectedMarker}
              />
            )}
          </div>
        ) : (
          <div className="scha__sp__details-card__right-loggedIn">
            {competences(selectedMarker.certifiedCompetences, selectedMarker.productCompetences)}
          </div>
        )}
      </div>
      {isDesktop && isCheckout && (
        <div className="scha__sp__details-card__right-loggedIn__confirm">
          <Button onClick={() => handleB2CCheckout(selectedMarker.subsidiaryId)}>
            {t("partnerFinder.search.confirm")}
          </Button>
        </div>
      )}
    </div>
  );
});
